module.exports = __webpack_public_path__ + "media/images/home/focus-bg-a507b01e4b4d3680c6bc5409bc1dbfc4.png";